import React, { useEffect, useRef } from 'react';
import { isEs } from "../libs/lang";

const Disclaimers = ({route, shouldBeInert}) => {
	const containerRef = useRef(null)
	useEffect(() => {
		if (containerRef.current) {
			if (shouldBeInert) {
				containerRef.current.setAttribute('inert', '');
				// containerRef.current.setAttribute('tabIndex', '-1');
				// containerRef.current.setAttribute('aria-hidden', 'true');
			}
			else {
				containerRef.current.removeAttribute('inert');
				// containerRef.current.removeAttribute('tabIndex');
				// containerRef.current.removeAttribute('aria-hidden');
			}
		}
	}, [shouldBeInert])

	return (
		<div id="disclaimers" ref={containerRef}>
			<div className="border"/>
			{route === 'sustainability' && (
				<>
					<ul>

						<li className='display-block'>Important notice regarding use of cookies: By continuing to use this site, you agree to our use of cookies as described in our <a href="https://www.wellsfargo.com/privacy-security/" target="_blank" rel="noreferrer">Digital Privacy and Cookies Policy</a>.</li>
						<li>Nonprofit name and address are from the 2021 Internal Revenue Service tax filings. Other nonprofit data are from the 2021 Wells Fargo list of grantees.</li>

					</ul>
				</>
			)}
			{route === 'housing' && (
				<ul>
					<li>
					<p>
					<a href="#ref-1" onClick={(e) => {
							e.preventDefault();
							document.querySelector('#ref-1').focus();
							window.scrollBy(
								0,
								document.querySelector('#ref-1').getBoundingClientRect().top - document.querySelector('nav').getBoundingClientRect().height
							);
						}}
						onKeyUp={(e) => {if(e.which === '13'){
							e.preventDefault();
							document.querySelector('#ref-1').focus();
							window.scrollBy(
								0,
								document.querySelector('#ref-1').getBoundingClientRect().top - document.querySelector('nav').getBoundingClientRect().height
							);
						}}} id="footnote-1" className="disc-sup footnote-num" data-go-to="ref-1">*</a>
					{
						isEs() ?
						<>
					El crédito para los costos de cierre <span lang="en">Dream. Plan. Home.</span> podría ayudar a los consumidores elegibles a comprar su residencia principal. El crédito para los costos de cierre está diseñado para consumidores con ingresos del 80% o menos de la mediana de ingresos del área (<span lang="en">AMI</span>, por sus siglas en inglés) donde se encuentra la propiedad. El crédito para los costos de cierre está disponible en ciertas áreas y no está disponible con todos los tipos de préstamo. Habla con un consultor hipotecario para obtener más detalles.
						</>
						:
						<>
						The Dream. Plan. Home. closing cost credit may help eligible consumers purchasing their primary residence. The closing cost credit is designed for consumers with income at or below 80% of the area median income (AMI) of the property location. The closing cost credit is available in certain areas and is not available with all loan types. Please speak with a home mortgage consultant for details.
						</>
					}
					</p>
					</li>
				</ul>
			)}
			<p><a href="https://www.mapbox.com/about/maps/" target="_blank" rel="noreferrer"><span lang="en">Maps &copy; Mapbox &copy; OpenStreetMap</span>{isEs() ? ` (en inglés)` : ``}</a></p>
			{
				route === 'home' && (
					<>
					<p>
					<a href="#ref-1" id="footnote-1" className="disc-sup footnote-num" data-go-to="ref-1" style={{marginRight: '1rem'}}
						onClick={(e) => {
							e.preventDefault();
							document.querySelector('#ref-1').focus();
							window.scrollBy(
								0,
								document.querySelector('#ref-1').getBoundingClientRect().top - document.querySelector('nav').getBoundingClientRect().height
							);
						}}
						onKeyUp={(e) => {if(e.which === '13'){
							e.preventDefault();
							document.querySelector('#ref-1').focus();
							window.scrollBy(
								0,
								document.querySelector('#ref-1').getBoundingClientRect().top - document.querySelector('nav').getBoundingClientRect().height
							);
						}}}
						aria-label="Footnote 1 - anchors to footnote in body copy"
					>1.</a>
					{
						isEs() ? <> Las cifras de empleo citadas reflejan datos autorreportados de beneficiarios del <span lang='en'>Open for Business Fund</span> (Fondo “Abiertos al Público”) de Wells Fargo para puestos de trabajo creados o retenidos durante 2020 – 2023.</> : <>Jobs figures cited reflect self-reported data from Wells Fargo Open for Business Fund grantees for jobs created or retained during 2020 - 2023.</>
					}
					</p>
					</>
				)
			}
			{route !== 'sustainability' && (
				<p>
					{
						isEs() ?
						<>
						El apoyo filantrópico de <span lang="en">Wells Fargo</span> incluye contribuciones de <span lang="en">Wells Fargo &amp; Company, Wells Fargo Bank, N.A.</span> y <span lang="en">Wells Fargo Foundation.</span>
						</>
						:
						<>
						Wells Fargo’s philanthropic support includes contributions from Wells Fargo &amp; Company, Wells Fargo Bank, N.A. and the Wells Fargo Foundation.
						</>
					}
				</p>
			)}
		</div>
	)
};

export default Disclaimers;
